import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon, CircleXMarkOutlined } from 'assets/icons';
import { createPromotionPadding } from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/CreatePromotion.styled';
import { theme } from 'styles';
import { Box, Flex, Icon, Text } from 'UI';

interface CreatePromotionHeaderProps {
  currentStep: number;
  prevStep: () => void;
  handleCancel: () => void;
}

const CreatePromotionHeader = ({ currentStep, prevStep, handleCancel }: CreatePromotionHeaderProps) => {
  const { t } = useTranslation();
  const isFirstStep = currentStep === -1;
  return (
    <Flex
      justify={'space-between'}
      minHeight={isFirstStep ? 100 : 60}
      maxHeight={isFirstStep ? 100 : 60}
      background={isFirstStep ? theme.color.white_dim_light_130 : theme.color.white}
      padding={createPromotionPadding}
      data-cy={'create-promotion-header'}
    >
      {isFirstStep ? (
        <Flex direction={'column'}>
          <Text type={'h1_black'} disableGutter data-cy={'create-new-promotion-text'}>
            {t('promotion.actions.create_new', 'Create new promotion')}
          </Text>
          <Text type={'h5_light'}>
            {t('promotion.actions.create_new.description', 'What type of promotion would you like to create?')}
          </Text>
        </Flex>
      ) : (
        <Box>
          <Flex onClick={prevStep} align={'center'} gap={10} data-cy={'previous-button'}>
            <Icon IconComponent={ArrowLeftIcon} size={16} />
            <Text disableGutter type="lg" bold cursor={'pointer'}>
              {t('common.action.previous', 'Previous')}
            </Text>
          </Flex>
        </Box>
      )}
      <Icon IconComponent={CircleXMarkOutlined} size={37} onClick={handleCancel} data-cy="cancel-promotion-modal" />
    </Flex>
  );
};

export default CreatePromotionHeader;
